import get from 'lodash/get';

export const canlistTools = (permissions) =>
  [
    'users.update',
    'brands.update',
    'clients.update',
    'opportunities.export',
    'opportunities.manage',
  ].some((path) => get(permissions, path));

const helpers = {
  canlistTools,
};

export default helpers;
